// ======================================================================
// File Name       : MessageView
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';

const SHOW_MESSAGE_TIMEOUT = 3000;

class MessageView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props.message };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps.message });
  }

  componentWillUnmount() {
    // clearTimeout(this.showMessageTimeout);
    if (!this.state.targetModal && this.props.onDismiss) {
      this.props.onDismiss();
    }
  }

  render() {
    const { messageVisible, messageType, messageHeader, messageContent, dismissible = true } = this.state;
    const { onDismiss } = this.props;
    const getMessage = (message) => {
      if (message) {
        if ($.type(message) === 'string') {
          return (
            <p>
              {message}
            </p>
          );
        } else if ($.type(message) === 'array') {
          return (
            message.map((msg, index) =>
              (<p key={index}>
                {msg}
              </p>),
          ));
        }
      }
      return null;
    };
    return (
      <div>
        {messageVisible &&
          <Alert className="messageDiaglog " variant={messageType} dismissible={dismissible} onClose={onDismiss}>
            {messageHeader &&
              <h4>
                {messageHeader}
              </h4>}
            {
              <div>
                {getMessage(messageContent)}
              </div>
            }
          </Alert>}
      </div>
    );
  }
}

export default MessageView;
